module.exports = __webpack_public_path__ + "static/media/checklist.dd080848.png";